export default {
    init() {
        // JavaScript to be fired on the investor page
        window.onload = function() {
          var recaptcha = document.forms['form']['g-recaptcha-response'];
          recaptcha.required = true;
          recaptcha.oninvalid = function() {
            // do something
            alert('Please complete the captcha');
          }
        }
    },
};
  


// WEBPACK FOOTER //
// ./scripts/routes/investors.js